import React from 'react';
import { useInput, FieldTitle } from 'react-admin';
import { FormControl, FormHelperText, InputLabel, Box } from '@mui/material';
import ColorPicker from './color-picker'; // Adjust the import path as necessary

const ColorInput = ({ source, label, ...rest }) => {
  const {
    field: { value = '#000000', onChange },
    fieldState: { error, touched },
  } = useInput({ source });

  const handleChangeComplete = (color) => {
    onChange(color);
  };

  const id = `color-picker-${source}`;

  return (
    <FormControl error={touched && !!error} margin="normal" fullWidth>
      <InputLabel htmlFor={id} shrink>
        <FieldTitle label={label} source={source} />
      </InputLabel>
      <Box display="flex" alignItems="center">
        <ColorPicker
          color={value}
          onChangeComplete={handleChangeComplete}
          id={id}
          {...rest}
        />
      </Box>
      {touched && error && (
        <FormHelperText>{error.message}</FormHelperText>
      )}
    </FormControl>
  );
};

export default ColorInput;
